/** Existing company-type todo steps apply only to these activities. */
export function companyRequiresEidsTodo(activity: string | null | undefined): boolean {
    return activity === 'real_estate' || activity === 'car_dealership';
}

export type EidsKind = 'property' | 'vehicle';

export interface EidsTagNode {
    id?: number;
    tags?: string[] | null;
    parent?: number | null;
}

/**
 * Real-estate wins when both tags are present. Other categories return null.
 */
export function eidsKind(category: EidsTagNode | null | undefined, lookup?: (id: number) => EidsTagNode | undefined): EidsKind | null {
    if (!category) {
        return null;
    }

    const tags: string[] = [];
    let current: EidsTagNode | undefined = category;
    const seen = new Set<number>();
    while (current) {
        if (typeof current.id === 'number') {
            if (seen.has(current.id)) {
                break;
            }
            seen.add(current.id);
        }
        tags.push(...(current.tags ?? []));
        if (typeof current.parent !== 'number' || !lookup) {
            break;
        }
        current = lookup(current.parent);
    }

    if (tags.includes('real_estate')) {
        return 'property';
    }
    if (tags.includes('vehicles')) {
        return 'vehicle';
    }
    return null;
}

export function eidsAuthorizationActive(authorization: { status?: string; ilanSuresi?: string | null } | null | undefined, now = Date.now()): boolean {
    if (!authorization || authorization.status !== 'authorized' || !authorization.ilanSuresi) {
        return false;
    }
    const until = Date.parse(authorization.ilanSuresi);
    return !Number.isNaN(until) && until > now;
}
